import { createRootRoute, Outlet } from '@tanstack/react-router'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { ToastContainer } from '#components/primitives/components/toast-container.tsx'
import { OfflineBanner } from '#components/primitives/components/offline-banner.tsx'
import { NoticeProvider } from '#ynt-design-system/components/notice/index.ts'
import { AuthGuard } from '#components/tools/auth-guard.tsx'
import { NotFoundPage } from '#components/tools/not-found-page.tsx'
import { CompanyLessPath } from '#components/domain/auth/user/shared/company-less-path.tsx'

export const Route = createRootRoute({
  notFoundComponent: () => (
    <AuthGuard navigateToLoginOnFailure={true}>
      <CompanyLessPath fallback={<NotFoundPage />} />
    </AuthGuard>
  ),
  component: () => (
    <>
      <NuqsAdapter>
        <NoticeProvider>
          <Outlet />
        </NoticeProvider>
      </NuqsAdapter>
      <OfflineBanner />
      <ToastContainer />
      
      {import.meta.env.VITE_MOCK_API !== '1' && (
        <div className='position-fixed bottom-0 start-0'>
          <TanStackRouterDevtools
            position='bottom-left'
            toggleButtonProps={{ style: { left: '50%', transform: 'translateX(-50%)' } }}
          />
        </div>
      )}
    </>
  ),
})